<template>
  <div class="proLogPage">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column prop="id" label="Request ID" align="center" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span class="allowSkip" @click="$processLogDetail(scope.row)">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="key" label="Key" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.key ? scope.row.key : '-'" placement="top" :open-delay="300">
            <div class="textOverflow">
              {{ scope.row.key ? scope.row.key : "-" }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="plant" label="车间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.plant">{{ scope.row.plant.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="organization" label="线体" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.organization">{{ scope.row.organization.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="workStation" label="工序" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.workStation">{{ scope.row.workStation.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="员工" align="center" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{ scope.row.user.name }}({{scope.row.user.employeeNum}})</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="requestDateTime" label="操作时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="requestData" label="请求参数" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" placement="top" :open-delay="300">
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.requestData, null, 2) }}</div>
            <div class="textOverflow" v-if="scope.row.requestData">{{scope.row.requestData}}</div>
          </el-tooltip>
          <span v-if="!scope.row.requestData">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="returnCode" label="错误代码" align="center" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="{danger: scope.row.returnCode != 0}">{{ scope.row.returnCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="returnMsg" label="返回信息" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" placement="top"
            :content="scope.row.returnMsg"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.returnMsg">{{scope.row.returnMsg}}</div>
          </el-tooltip>
          <span v-if="!scope.row.returnMsg">-</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getFactoryLogSearch"></pagination>
  </div>
</template>
<script>
import pagination from "@/components/pagination.vue";
import { apiFactoryLogSearch } from "@/api/productionOrder.js";
export default {
  components: {
    pagination,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    proLogForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  methods: {
    // 表格数据
    async getFactoryLogSearch(remove, isExport, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiFactoryLogSearch({
        orderId: this.tabPaneValue,
        ...this.proLogForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        export: isExport,
        orderBy: this.orderBy,
      });
      if (isExport) {
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      } else {
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.total = res.total;
          this.pagination.beginIndex = res.beginIndex;
          this.pagination.endIndex = res.endIndex;
          if (callback) callback();
        }
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFactoryLogSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getFactoryLogSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getFactoryLogSearch();
    },
  },
};
</script>

<style lang="less" scoped>
.proLogPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>